    /*
 * Espace global - Utilisez avec précaution
 */
window.TABLE_PARENT = 'table-evenements';
window.TABLE_ENFANT = 'details-table';

// initialisation de la page
$(function (){
    $(document).off('click', '#lien-modal-contact-proprietaire').on('click', '#lien-modal-contact-proprietaire', function () {
        var url = $(this).data('url');
        call_ajax(url, 'GET', undefined, function (response) {
            $('#modal-contact-proprietaire .modal-body').html(response);
            $('#modal-contact-proprietaire').modal('show');
        });
    });
});
/**
 * Initialisation de la tenue à jour au chargement du module.
 */

// Espace de nom réservé à l'utilisation des boutons et de leurs actions (global)
var tenueAJourBoutons = {

    initialiserBoutonFiltre: function (a) {

        var selection = a.target.value; // Donnée avec chemin pour m_listeFiltres
        if (selection == "") {
            return;
        }

        var selectionText = $(a.target).children(":selected").text(); // Contenu du champs sélectionné. Pour les dates, voir la fonction déclencheur ".on('apply.daterangepicker',"
        var resultat = regEx.decomposeIdFiltre(selection, '-');
        var titre = regEx.decomposeNomSelectFiltre(selectionText);
        filtresEvenements.ajouteSousFiltreRecherche(resultat, titre);
        a.target.options.selectedIndex = 0;
        // On doit forcer le rafraichissement de Select2 sinon on voit toujours l'option choisie même si la liste derrière a été mise à jour !
        $(a.target).select2("val", "");
    },
};

var filtresEvenements = (function () {

    var m_listeFiltres;

    /**
     * Getter pour la variable privée m_listeFiltres.
     * @return {object} m_listeFiltres - l'objet pour la gestion de la liste des filtres dynamiques.
     */
    function reqListeFiltres() {
        return m_listeFiltres;
    }


    /**
     * Setter pour la variable privée m_listeFiltres.
     * @param {object} listeFiltres - Objet listeFiltres passé en paramètre (passage par référence, on suppose).
     */
    function asgListeFiltres(listeFiltres) {
        m_listeFiltres = listeFiltres;
    }


    /**
     * Getter pour la variable privée m_listeChampsFiltres.
     * @return {object} m_listeChampsFiltres - l'objet pour la gestion des champs de la liste des filtres dynamiques.
     */
    function reqListeChampsFiltres() {
        return m_listeChampsFiltres;
    }

    function reqColonnesDef() {
        return m_colonnesDef;
    }

    function asgColonnesDef(colonnesDef) {
        m_colonnesDef = colonnesDef;
    }

    /**
     * Ajouter un tag aux filtres de recherche dynamiques.
     *  @desc Ajouter un filtre de recherche à l'objet javascript créé par la fonction chargerTagsFiltresRecherche() au démarrage de l'application.
     *  @param {string} resultat - la colonne (TD) utilisé pour le filtre (évènement, date, assignation, etc.) : est le nom de l'alias dans la BD ou le nom du champs.
     *  @param {Number} titre - l'id de l'élément utilisé pour filtrer le champs (ex : id_evenement = 5).
     */
    function ajouteSousFiltreRecherche(resultat, titre) {

        var colonne = resultat[0];
        var id = resultat[2].replace(/-/g, '').replace(/\./g, '').replace(/ /g, '').replace(/\t/g, '');
        var compteur = 0;
        var index;

        if (m_listeFiltres.champs[colonne].parametres[0].form === "input") {
            if (m_listeFiltres.champs[colonne].parametres[0].form_add_to_page === "oui") {
                m_listeFiltres.champs[colonne].parametres[0].contenu = '';
                index = m_listeFiltres.champs[colonne].filtres.length;
                for (var i = 0; i < (m_listeFiltres.champs[colonne].filtres).length; i++) {
                    if (id == m_listeFiltres.champs[colonne].filtres[i].id) {
                        compteur += 1;
                    }
                }
                if (compteur === 0) {
                    index = m_listeFiltres.champs[colonne].filtres.length;
                    if (titre.indexOf('-') === 0) { // On gère les numériques négatifs pour les unités d'évaluation
                        id = titre.replace('-', '_');
                    }
                    m_listeFiltres.champs[colonne].filtres.push({
                        "nom": titre,
                        "id": id,
                        "etat": "Actif",
                        "contenu": ""
                    });
                }
            } else {
                m_listeFiltres.champs[colonne].filtres[0].contenu = titre;
                index = 0;
            }
        } else if (m_listeFiltres.champs[colonne].parametres[0].form === "date") {
            if (titre.length > 10) {
                var range = regEx.decomposeDateRange(titre);
                m_listeFiltres.champs[colonne].filtres[0].debut = range[0];
                m_listeFiltres.champs[colonne].filtres[0].fin = range[1];
            } else {
                m_listeFiltres.champs[colonne].filtres[0].debut = titre;
                m_listeFiltres.champs[colonne].filtres[0].fin = "";
            }
        } else {
            for (var i = 0; i < (m_listeFiltres.champs[colonne].filtres).length; i++) {
                if (id == m_listeFiltres.champs[colonne].filtres[i].id) {
                    compteur += 1;
                }
            }
            if (compteur === 0) {
                index = m_listeFiltres.champs[colonne].filtres.length;
                m_listeFiltres.champs[colonne].filtres.push({
                    "nom": titre,
                    "id": id,
                    "etat": "Actif",
                    "contenu": ""
                });
            }
        }
        ajouteUnTagFiltresRecherche(resultat, index);
        toggleBoutonAppliquerFiltreRecherche('#appliquer-filtre', 'Actif');
    }


    /**
     * Passer les paramètres à la vue pour exécuter la requête.
     * @desc Les paramètres sont passés côté serveur un string WHERE est retourné à DataTables.
     */
    function faitAppliquerFiltreRecherche() {

        // Mettre à jour tous les autres input dans l'objet.
        var i_key;
        var j_key;
        var listeFiltres = reqListeFiltres();
        var condition = " ";
        var equals = ' = ';
        var like = ' LIKE ';
        var notLike = ' NOT LIKE ';
        var notEquals = ' <> ';
        var and = ' AND ';
        var or = ' OR ';
        var isSmaller = ' <= ';
        var isGreater = ' >= ';
        var isBetween = ' BETWEEN ';
        var donneeForm;

        for (i_key in listeFiltres.champs) {
            var filtre = listeFiltres['champs'][i_key]['filtres'];
            var nomChamp = listeFiltres['champs'][i_key]['parametres'][0].champ;
            var quotes = ((listeFiltres['champs'][i_key]['parametres'][0].single_quotes === 'oui') ? "'" : "");

            if ((listeFiltres['champs'][i_key]['parametres'][0].buttons === 'oui') && (nomChamp != "")) { // On ramasse tous les filtres qui comportent des boutons (actif, actifexclusif ou inactif) pour les filtres : ajouts simples ou multiples au dessus des champs.
                var conditionInclusif = ''; // On gère deux strings, une qui cumule les or x = n et celles qui excluent systématiquement des paramètres et variables.
                var conditionExclusif = '';
                var jCompteurInit = 0;
                var jCompteurCast = 0;
                var donnee;
                // On vérifie si le champ input contient une donnée qui n'a pas été mise en bouton. Dans ce cas, on récupère la donnée.
                if ((nomChamp != "") && (listeFiltres['champs'][i_key]['parametres'][0].form === 'input') && (listeFiltres['champs'][i_key]['parametres'][0].contenu != "")) {
                    conditionInclusif += (jCompteurInit > 0 && condition !== ' ') ? jCompteurInit > 0 && (conditionExclusif !== '' && conditionInclusif === '') ? '' : or : condition !== ' ' && (conditionExclusif !== '' || conditionInclusif === '') ? and + '(' : '';

                    var nom = nomChamp;
                    if ((listeFiltres['champs'][i_key]['parametres'][0].lower_case === 'oui')) {
                        nom = "lower(" + nom + ")";
                    }

                    conditionInclusif += nom + (' ' + listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison + ' ');
                    donnee = listeFiltres['champs'][i_key]['parametres'][0].contenu;

                    // DM: hack qui change la donnée pour 0 lorsque c'est un int qui ne contient pas que des digits, dans le but que rien ne soit retourné dans le tableau au lieu de planter
                    if (listeFiltres['champs'][i_key]['parametres'][0].form_type == 'int' && !(/^\d+$/.test(donnee))) {
                        donnee = '0';
                    }

                    var valeur = "";

                    if ((listeFiltres['champs'][i_key]['parametres'][0].cast_as_varchar === 'oui')) {
                        valeur += 'CAST(';
                    }
                    valeur += quotes + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison == 'LIKE' ? '%' : '') + donnee + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison == 'LIKE' ? '%' : '') + quotes + ((listeFiltres['champs'][i_key]['parametres'][0].cast_as_varchar === 'oui') ? ' AS VARCHAR)' : '');

                    if ((listeFiltres['champs'][i_key]['parametres'][0].lower_case === 'oui')) {
                        valeur = "lower(" + valeur + ")";
                    }

                    conditionInclusif += valeur;
                }
                for (j_key = 0; j_key < filtre.length; j_key++) {
                    donnee = ['no_reference', 'matricule'].indexOf(nomChamp) >= 0 ? filtre[j_key].nom : filtre[j_key].id.replace("_", "-"); // lien vers l'id de la base de données.
                    if (condition === ' ' && (filtre[j_key].etat === 'Actif' || filtre[j_key].etat === 'gel')) {
                        condition += '(';
                        if (conditionInclusif !== '') {
                            conditionInclusif += or;
                        }
                        conditionInclusif += nomChamp + (' ' + listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison + ' ');
                        if ((listeFiltres['champs'][i_key]['parametres'][0].cast_as_varchar === 'oui')) {
                            conditionInclusif += 'CAST(';
                        }
                        conditionInclusif += quotes + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison == 'LIKE' ? '%' : '') + donnee + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison == 'LIKE' ? '%' : '') + quotes + ((listeFiltres['champs'][i_key]['parametres'][0].cast_as_varchar === 'oui') ? ' AS VARCHAR)' : '');
                        jCompteurInit += 1;
                    } else if (condition === ' ' && (filtre[j_key].etat === 'ActifExclusif')) {
                        condition += '(';
                        conditionExclusif += nomChamp + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison === 'LIKE' ? notLike : notEquals);
                        if ((listeFiltres['champs'][i_key]['parametres'][0].cast_as_varchar === 'oui')) {
                            conditionExclusif += 'CAST(';
                        }
                        conditionExclusif += quotes + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison == 'LIKE' ? '%' : '') + donnee + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison == 'LIKE' ? '%' : '') + quotes + ((listeFiltres['champs'][i_key]['parametres'][0].cast_as_varchar === 'oui') ? ' AS VARCHAR)' : '');
                        jCompteurInit += 1;
                    } else if (filtre[j_key].etat === 'Actif' || filtre[j_key].etat === 'gel') {
                        conditionInclusif += (jCompteurInit > 0 && condition !== ' ') ? jCompteurInit > 0 && (conditionExclusif !== '' && conditionInclusif === '') ? '' : or : condition !== ' ' && (conditionInclusif !== '') ? or : and + '(';
                        conditionInclusif += nomChamp + (' ' + listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison + ' ');
                        if ((listeFiltres['champs'][i_key]['parametres'][0].cast_as_varchar === 'oui')) {
                            conditionInclusif += 'CAST(';
                        }
                        conditionInclusif += quotes + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison == 'LIKE' ? '%' : '') + donnee + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison === 'LIKE' ? '%' : '') + quotes + ((listeFiltres['champs'][i_key]['parametres'][0].cast_as_varchar === 'oui') ? ' AS VARCHAR)' : '');
                        jCompteurInit += 1;
                    } else if (filtre[j_key].etat === 'ActifExclusif') {
                        if (jCompteurInit > 0 && condition !== ' ') {
                            if (jCompteurInit > 0 && (conditionExclusif !== '' && conditionInclusif !== '')) {
                                conditionExclusif += and;
                            } else {
                                if (jCompteurInit > 0 && (conditionExclusif !== '')) {
                                    conditionExclusif += and;
                                } else {
                                    conditionExclusif += '';
                                }
                            }
                        } else {
                            conditionExclusif += and + '(';
                        }
                        // conditionExclusif += (jCompteurInit > 0 && condition !== ' ') ? jCompteurInit > 0 && (conditionExclusif !== '' && conditionInclusif === '') ? '' : jCompteurInit > 0 && (conditionExclusif !== '' && conditionInclusif !== '') ? '' : and : and + '(';

                        conditionExclusif += nomChamp + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison === 'LIKE' ? notLike : notEquals);
                        if ((listeFiltres['champs'][i_key]['parametres'][0].cast_as_varchar === 'oui')) {
                            conditionExclusif += 'CAST(';
                        }
                        conditionExclusif += quotes + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison == 'LIKE' ? '%' : '') + donnee + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison == 'LIKE' ? '%' : '') + quotes + ((listeFiltres['champs'][i_key]['parametres'][0].cast_as_varchar === 'oui') ? ' AS VARCHAR)' : '');
                        jCompteurInit += 1;
                    }
                }
                if (conditionInclusif.indexOf('AND') === 1) {
                    condition += conditionInclusif + (conditionExclusif !== '' ? and + '(' + conditionExclusif + ')' : '');
                } else if (conditionExclusif.indexOf('AND') === 1) {
                    condition += conditionExclusif + (conditionInclusif !== '' ? and + '(' + conditionInclusif + ')' : '');
                } else if (!(conditionInclusif.indexOf('AND') === 1) && !(conditionExclusif.indexOf('AND') === 1) && conditionInclusif !== '' && conditionExclusif !== '') {
                    condition += '(' + conditionInclusif + ')' + and + '(' + conditionExclusif + ')';
                } else {
                    condition += (condition === ' ' && (conditionInclusif !== '' && conditionInclusif.indexOf('(') !== 0) ? '(' : '') + (conditionInclusif !== '' ? conditionInclusif : conditionExclusif !== '' ? conditionExclusif : '');
                }
                condition += (condition !== ' ' && jCompteurInit > 0) ? conditionExclusif !== '' && conditionInclusif !== '' ? (condition.indexOf('((') !== 0) ? ')' : '))' : ')' : conditionExclusif !== '' || conditionInclusif !== '' ? ')' : '';
            } else if ((listeFiltres['champs'][i_key]['parametres'][0].form === 'date') && (nomChamp != "")) {
                if (!listeFiltres['champs'][i_key]['parametres'][0].contenu) {
                    continue;
                } else if (!($.trim(listeFiltres['champs'][i_key]['parametres'][0].contenu))) { // On vérifie simplement que la chaîne de caractère passée n'est pas un espace vide ou plusieurs d'espaces.
                    continue;
                }

                if (!listeFiltres['champs'][i_key]['parametres'][0].singleDatePicker) {
                    var debut = ((listeFiltres['champs'][i_key]['parametres'][0].debut !== "" || listeFiltres['champs'][i_key]['parametres'][0].debut !== undefined)) ? listeFiltres['champs'][i_key]['parametres'][0].debut : "";
                    var fin = ((listeFiltres['champs'][i_key]['parametres'][0].fin !== "" || listeFiltres['champs'][i_key]['parametres'][0].fin !== undefined)) ? listeFiltres['champs'][i_key]['parametres'][0].fin : "";
                    // On fait un CAST comme date pour effectuer des recherche avec BETWEEN : dateRangePicker permet de choisir aujourd'hui et le défini comme un range.
                    // Dans le cas ou l'utilisateur a effacé une des deux dates, on recopie debut dans la variable fin (et dans filtres[0].fin).
                    if (fin === "") {
                        fin = debut;
                        listeFiltres['champs'][i_key]['parametres'][0].fin = listeFiltres['champs'][i_key]['parametres'][0].debut;
                    }
                    if (fin === debut) {
                        debut = debut + ' 00:00:00';
                        fin = fin + ' 23:59:59';
                    }

                    donneeForm = (debut !== "" && fin !== "") ? nomChamp + isBetween + "'" + debut + "'" + and + "'" + fin + "'" : "";
                } else {
                    var nomChampDebut = listeFiltres['champs'][i_key]['parametres'][0].champDebut;
                    var nomChampFin = listeFiltres['champs'][i_key]['parametres'][0].champFin;

                    var date = "'" + listeFiltres['champs'][i_key]['parametres'][0].contenu + "'";
                    donneeForm = nomChampDebut + ' <= ' + date + ' AND (' + nomChampFin + ' IS NULL OR ' + nomChampFin + ' > ' + date + ')';
                    //condition += ((condition === ' ') ? '(' : and + '(' ) + donneeForm + ')';
                }
                listeFiltres['champs'][i_key]['parametres'][0].donneeForm = donneeForm;

                // certaines conditions n'iront pas dans le WHERE principal, mais dans le WHERE d'un sous-select par exemple
                var whereNo = listeFiltres['champs'][i_key]['parametres'][0].whereNo;
                if (!whereNo) {
                    condition += ((condition === ' ') ? '(' : and + '(') + donneeForm + ')';
                }
            } else {
                if ((typeof (filtre[0]) === 'undefined') && (nomChamp != "") && (listeFiltres['champs'][i_key]['parametres'][0].form === 'input')) {
                    donneeForm = listeFiltres['champs'][i_key]['parametres'][0].contenu;
                } else if ((filtre[0].contenu != "") && (nomChamp != "")) {
                    donneeForm = filtre[0].contenu;
                }
                if (typeof (donneeForm) !== 'undefined') {
                    condition += ((condition === ' ') ? "" : and) + '(';
                    condition += nomChamp + (' ' + listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison + ' ');
                    condition += ((listeFiltres['champs'][i_key]['parametres'][0].cast_as_varchar === 'oui') ? 'CAST(' : '');
                    condition += quotes + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison == 'LIKE' ? '%' : '') + donneeForm + (listeFiltres['champs'][i_key]['parametres'][0].operateur_comparaison == 'LIKE' ? '%' : '') + quotes;
                    condition += ((listeFiltres['champs'][i_key]['parametres'][0].cast_as_varchar === 'oui') ? ' AS VARCHAR)' : '') + ')';
                }
            }
            donneeForm = undefined;
        }
        (condition === ' ') ? condition = "1=1" : condition;

        // Hack : temporairement, on valide que AND (AND ne se produise pas. Les utilisateurs réussissent avec des copier-coller à insérer des caractères inconnus ou des espaces qui font planter. Cette partie est refaite dans le mode bureau et terrain.
        if (condition.indexOf('AND ( AND') > 0) {
            condition = condition.replace(/AND \( AND/g, 'AND (');
        }
        return condition;
    }


    /**
     * Mise en évidence du bouton (Appliquer les filtres) selon l'état.
     * @desc Au chargement, le bouton est grisé. Lors d'une modification dans les filtres, on active le bouton
     *          pour aviser du rafraîchissement possible.
     * @param {string} element - Le nom de l'élément (ID) à affecter pour le changement d'état.
     * @param {string} etat - Le nom de l'élément (ID) à affecter pour le changement d'état.
     *
     * TODO(gary) Implantation d'un temps d'attente pour éviter l'utilisation du bouton à répétition
     *
     */
    function toggleBoutonAppliquerFiltreRecherche(element, etat) {

        var active = 'btn-info';
        var inactive = 'btn-light';
        var elem = element;

        if (etat === 'Actif') {
            $(elem).removeClass(inactive).addClass(active);
        } else {
            $(elem).removeClass(active).addClass(inactive);
        }
    }

    /**
     * Obtenir la liste des filtres de recherche.
     * @param {bool} init : True s'il s'agit de l'initialisation du module et false pour tous les autres cas.
     */
    function reqTagsFiltresRecherche(init) {

        if (init) {

            var champsDynamiques = dessineTagsFiltresRecherche(reqListeFiltres());
            faitAppliquerFiltreRecherche();
            chargerTagsFiltresRecherche(champsDynamiques, function () {
                $('#panneau-filtres-actions')[controlesFormulaires.toggleAddRemoveClass(this.value)]('x');
            });
        }

    }

    /**
     * Ajouter un élément des filtres de recherche.
     * @param {string} element - L'élément qui doit être ajouté à la structure de données et au DOM.
     * @param {number} index - l'index du nouvel élément inséré dans la structure de données (objet).
     */
    function ajouteUnTagFiltresRecherche(element, index) {

        var listeFiltres = m_listeFiltres.champs;
        var colonne = element[0];
        var champ = element[1];
        var id = element[2].replace('-', '').replace('.', '');
        var html = '';
        var etatBouton = (listeFiltres.etat === "Inactif") ? 'btn-light' : 'btn-success';
        if (listeFiltres[colonne].parametres[0].buttons === "oui" && listeFiltres[colonne].parametres.length > 0) {
            html += '<div><button id="' + colonne + '-' + listeFiltres[colonne].parametres[0].champ + '-' + listeFiltres[colonne].filtres[index].id + '" value="' + colonne + '-' + listeFiltres[colonne].parametres[0].champ + '-' + listeFiltres[colonne].filtres[index].id + '" filtre="' + listeFiltres[colonne].parametres[0].titre + '" class="filtre btn btn-sm ' + etatBouton + '" title="' + (etatBouton == "gel" ? "" : "Cliquez pour activer (2 états) ou désactiver ce filtre") + '">' + listeFiltres[colonne].filtres[index].nom + '</button><button id="' + colonne + '-' + listeFiltres[colonne].parametres[0].champ + '-' + listeFiltres[colonne].filtres[index].id + '-effacer" value="' + colonne + '-' + listeFiltres[colonne].parametres[0].champ + '-' + listeFiltres[colonne].filtres[index].id + '-effacer" value="' + colonne + '-' + listeFiltres[colonne].parametres[0].champ + '-' + listeFiltres[colonne].filtres[index].id + '-effacer" class="filtre-close btn btn-sm ' + etatBouton + ' filtre" title="Effacer ce filtre"><i class="fa ' + (etatBouton == "gel" ? "fa-lock" : "fa-times") + '"></i></button></div>';
        } else {
            if (listeFiltres[colonne].parametres[0].form === "text") {
                html += '<input type="text" class="col-xs-12" id="' + colonne + '-' + champ + '-text" disabled value="' + listeFiltres[colonne].filtres[index].nom + '">';
            }
        }

        var formType = listeFiltres[colonne].parametres[0].form;

        switch (formType) {
            case "select":
                break;
            case "input":
                // html += '<input type="text" class="col-xs-12" placeholder="' + listeFiltres[colonne].parametres[0].titre + '" id="' + colonne + '-' + champ + '-' + 'input' + '">';
                $('#' + champ).val("");
                break;
            case "date" :
                html += '<div class="input-group">' +
                    '<span class="input-group-addon">' +
                    '<i class="ace-icon fa fa-calendar"></i>' +
                    '</span> ' +
                    '<input id="filtre-date-range-picker id-date-range-picker" name="date-range-picker" type="text" class="form-control">' +
                    '</div>';
                break;
        }
        $(html).insertBefore('#' + champ);
    }

    /**
     * Afficher les boutons des tags Filtres de recherche à l'écran, à leur place.
     * @param {object} listeFiltres - L'objet listeFiltres.
     * @return {string} html - le contenu du panneau des filtres formaté.
     */
    function dessineTagsFiltresRecherche(listeFiltres) {

        $('#table-filtres').empty();

        var listeParametres = listeFiltres.parametres;
        var listeEvenements = listeFiltres.champs;
        var parametres = [];


        var html = '<table class="table table-striped table-bordered table-hover display" id="' + TABLE_PARENT + '-filtre"><tbody><tr>';
        $.each(listeEvenements, function (key, value) {
            html += (key === listeParametres.colonneTri) ? '<td class="sorting_1" nowrap>' : '<td nowrap class="filtres">';
            html += '<h5>' + value.parametres[0].titre + '</h5>';
            var temp = key;
            $.each(value.filtres, function (key, value2) {
                html += (value.parametres[0].masque_format != '') ? '<p>Format : ' + value.parametres[0].masque_format + '</p>' : '';
                var etatBouton = (value2.etat === "Inactif") ? 'btn-light' : value2.etat === "gel" ? 'btn-primary' : value2.etat === "ActifExclusif" ? 'btn-danger' : 'btn-success';
                if (value.parametres[0].buttons === "oui") {
                    var etatEffacerFiltre = value2.etat === "gel" ? "fa-lock" : value.parametres[0].form === 'button' ? "fa-lock" : "fa-times";
                    html += '<div><button id="' + temp + '-' + value.parametres[0].champ + '-' + value2.id + '" value="' + temp + '-' + value.parametres[0].champ + '-' + value2.id + '" filtre="' + value.parametres[0].titre + '" class="filtre btn btn-sm ' + etatBouton + '" title="' + (etatBouton == "gel" ? "" : "Cliquez pour activer (2 états) ou désactiver ce filtre") + '">' + value2.nom + '</button><button id="' + temp + '-' + value.parametres[0].champ + '-' + value2.id + '-effacer" value="' + temp + '-' + value.parametres[0].champ + '-' + value2.id + '-effacer" value="' + temp + '-' + value.parametres[0].champ + '-' + value2.id + '-effacer" class="filtre-close btn btn-sm ' + etatBouton + ' filtre" title="Effacer ce filtre"><i class="fa ' + etatEffacerFiltre + '"></i></button></div>';
                } else {
                    if (value.parametres[0].form === "text") {
                        html += '<input type="text" size="25" id="' + temp + '-' + value.parametres[0].champ + '-input" disabled value="' + value2.nom + '">';
                    }
                }
            });

            var formType = value.parametres[0].form;

            switch (formType) {
                case "select":
                    parametres.push({
                        "nom": key,
                        "champ": value.parametres[0].champ,
                        "taille": value.parametres[0].taille
                    });
                    if (typeof (value.parametres[0].dependant_de) !== 'undefined') {
                        parametres[(parametres.length - 1)].dependant_de = value.parametres[0].dependant_de;
                    }
                    html += '<div id="' + value.parametres[0].champ + '"' + (typeof (value.parametres[0].dependant_de) !== 'undefined' ? ' data-dependant_de="' + value.parametres[0].dependant_de : '') + '"' + '></div>';
                    break;
                case "input":
                    html += '<input type="text" class="col-xs-12 ' + value.parametres[0].masque + ((value.parametres[0].clearable === "oui") ? " clearable" + (value.parametres[0].contenu.length > 0 ? " x onX" : "") : "") + '" placeholder="' + value.parametres[0].titre + '" id="' + value.parametres[0].champ + '"' + ' value="' + value.parametres[0].contenu + '"' + '" style="width:' + value.parametres[0].taille + ';">';
                    break;
                case "date" :
                    html += '<div class="input-group filtres" style="width:' + value.parametres[0].taille + ';">' +
                        '<span class="input-group-addon">' +
                        '<i class="ace-icon fa fa-calendar"></i>' +
                        '</span> ' +
                        '<input id="' + value.parametres[0].champ + '" + placeholder="' + value.parametres[0].titre + '" name="date-range-picker" type="text" class="form-control ' + ((value.parametres[0].clearable === "oui") ? "clearable" + (value.filtres[0] && value.filtres[0].contenu.length > 0 ? " x onX" : "") : "") + '" ' +
                        ((value.parametres[0].singleDatePicker) ? 'singleDatePicker="true"' : "") + ' ' +
                        ((value.parametres[0].debut && value.parametres[0].singleDatePicker) ? 'value="' + value.parametres[0].debut + '"' : "") +
                        ((value.parametres[0].contenu && !value.parametres[0].singleDatePicker) ? 'value="' + value.parametres[0].contenu + '"' : "") +
                        '>' +
                        '</div>';
                    break;
            }
            html += '</td>';
        });

        html += '</tr></tbody></table>';
        $('#table-filtres').append(html);

        dessineBoutonsActionFiltresRecherche();

        masquesSelection.init();

        return parametres;

    }

    /**
     * Afficher les boutons d'action sous les filtres de recherche.
     */
    function dessineBoutonsActionFiltresRecherche() {

        // On passe la requête vers le serveur pour valider si l'usager en cours peut ou non enregistrer un profil de filtres personnalisés ou non.
        $('#panneau-filtres-actions').empty();
        var params = {
            module_id: $("#sidebar li.active ul.submenu li.active a").attr('id_module')
        };

        var jqxhr = $.ajax({
            url: '/gestion-roles/tenue-a-jour/filtres/afficher-actions-filtres-user-group/',
            data: params,
            type: 'GET',
            dataType: 'html',
            async: false
        });
        jqxhr
            .done(function (response) {
                var html = response;
                $('#panneau-filtres-actions').append(html);
                controlesFormulaires.clearable();
            });
        jqxhr
            .fail(function (jqxhr, textStatus, errorThrown) {
                infos.ajouterMessageToast({
                    message: "Erreur de chargement des actions sur les filtres de la tenue à jour",
                    messageDuree: 5000,
                    messageCouleur: "red"
                });
            });
    }

    /**
     * Chargement des tags de filtres de recherche dynamiques.
     * @return {object} execution - le résultat de l'exécution du chargement de la liste des filtres.
     */
    function chargerTagsFiltresRecherche(champsDynamiques) {
        //console.log(champsDynamiques);
        var url = "/core/filtres/charger/";

        for (var i = 0; i < champsDynamiques.length; i++) {
            var champs = champsDynamiques[i];
            $.ajax({
                type: "GET",
                async: false, // nécessaire sinon, la boucle se termine avant l'exécution du call ajax : écrase le dernier champ utilisé.
                url: url,
                data: champs,
                dataType: 'html',
                success: function (response) {
                    var divChampDynamique = '#' + champs.champ;
                    var idChampDynamique = '#form-' + champs.champ;
                    $(divChampDynamique).html(response);
                    $(idChampDynamique).select2({
                        width: champs.taille,
                        dropdownAutoWidth: 'true'
                    });
                }
            });
        }
    }

    var m_listeChampsFiltres;
    var m_colonnesDef;

    // public API
    return {
        asgListeFiltres: asgListeFiltres,
        reqListeFiltres: reqListeFiltres,
        reqListeChampsFiltres: reqListeChampsFiltres,
        reqColonnesDef: reqColonnesDef,
        asgColonnesDef: asgColonnesDef,
        reqTagsFiltresRecherche: reqTagsFiltresRecherche,
        ajouteSousFiltreRecherche: ajouteSousFiltreRecherche,
        toggleBoutonAppliquerFiltreRecherche: toggleBoutonAppliquerFiltreRecherche,
        faitAppliquerFiltreRecherche: faitAppliquerFiltreRecherche,
        chargerTagsFiltresRecherche: chargerTagsFiltresRecherche,
    };

})(); // namespace tenueAJour


// TODO:OBSOLETE?2023-02-20
// TODO Générer cette liste à partir de m_listeFiltres et non la coder en dur
let icol=1;
var listeChampsFiltresTAJ = { // pour la population de dataTables // le générer à partir de l'objet m_listeFiltres.
    "liste": [
        {"title": "vide", "data": "vide", "targets": "vide"}, // utilisé pour éviter les erreurs dans la listes des columndefs de dataTables - Contrôles des Children.
        {"title": "vide", "data": "id_evenement", "targets": ++icol}, // utilisé pour éviter les erreurs dans la listes des columndefs de dataTables - CheckBoxes.
        {"title": "Évènement", "data": "type_description", "targets": ++icol},
        {"title": "Municipalité", "data": "id_municipalite", "targets": ++icol},
        {"title": "No référence", "data": "no_reference", "targets": ++icol},
        {"title": "No civique", "data": "no_civique", "targets": ++icol},
        {"title": "Voie publique", "data": "adresse_tri", "targets": ++icol},
        {"title": "ID (UE)", "data": "id_ue", "targets": ++icol},
        {"title": "Usage", "data": "id_type_batiment", "targets": ++icol}, // nmar (Non residentiel, Multirésidentiel, Agricole, Résidentel) - classé dans cet ordre.
        {"title": "État", "data": "statut_description", "targets": ++icol},
        {"title": "testDate de prise d'effet au rôle", "data": "date_evenement", "targets": ++icol},
        {"title": "Date envoi formulaire / avis", "data": "dates_formulaire", "targets": ++icol},
        {"title": "Fin prévue travaux", "data": "date_fin_travaux", "targets": ++icol},
        {"title": "Prochaine inspection", "data": "date_prochaine_inspection", "targets": ++icol},
        {
            "title": "Dernière attestation de vérification",
            "data": "date_derniere_attestation_verification",
            "targets": ++icol
        },
        {
            "title": "Dernière attestation de vérification complète",
            "data": "date_derniere_attestation_verification_complete",
            "targets": ++icol
        },
        {"title": "Assignation", "data": "last_name", "targets": ++icol},
        {"title": "Note de transmission", "data": "commentaire", "targets": ++icol},
        {"title": "Dernier état", "data": "date_dernier_statut", "targets": ++icol},
        {"title": "Matricule", "data": "matricule", "targets": ++icol},
        {"title": "Date de création", "data": "date_creation", "targets": ++icol},
        {'title': "Route d'inspection", "data": "route_identifiant", "targets": ++icol},
        {"title": "Code d'utilisation", "data": "id_code_utilisation", "targets": ++icol},
        {"title": "Cycle", "data": "cycle_nom", "targets": ++icol},
        {"title": "Remarque", "data": "remarque", "targets": ++icol},
    ]
};


// Espace de nom réservé aux fonctions et membres (privés et publics).
var tenueAJour = (function () {
    function cliquerCaseCocherLigneEvenement(element, table) {


        var $element = $(element);
        if ($element.is(":checked")) {
            $element.closest('tr').addClass('selected');
        } else {
            $element.closest('tr').removeClass('selected');
            $('#table-evenements_info').remove(".select-info");
        }
        // GG: On doit vérifier que si tous les boutons sont sélectionnés, on coche check-tj-select-all sinon, on décoche.
        var nomTable = table.context[0].sTableId;

        var cochee = false;
        if ($('#' + nomTable).find('input:checked').length === $('#' + nomTable).find('input').length) {
            cochee = true;
        }

        $element.closest('.table-template').find('.datatables-menu-actions [name=check-tj-select-all]').prop('checked', cochee);

        tenueAJour.activerActionsSurEvenementGrille($element, $element.is(":checked"), $(this).closest('tr').index());
    }

    function actionsBoutonsRuban(elementObj) {
        var conteneur = elementObj.closest('.table-template');
        var tableElem = conteneur.find('table.table');
        var element = elementObj.data('action');

        var table = tableElem.DataTable();
        if (element === 'check-tj-select-all') {
            var boutonsActionDisabled = controlesFormulaires.selectAll(tableElem, elementObj);
            activerDesactiverBoutonsRuban(conteneur, boutonsActionDisabled);
        }

        if ('conserverSelection' in table.settings) { // On conserve la sélection pour la réutiliser au rafraichissement du dataTables.
            table.settings.selection = table.rows('.selected').data('id_evenement');
        }

        if (element === 'btn-tj-assigner-et-etat') {
            tenueAJourModal.modalAssignerEtEtat();
        }

        if (element === 'btn-tj-date-inspection') {

            if (!$('#tenue-a-jour-modal-date-inspection').length) { // si la modal n'a pas déjà été chargé

                var variableDateInspection = {
                    id: "tenue-a-jour-modal-date-inspection",
                    view: "/core/modal/",
                    id_processus: "",
                    titre: "Date Inspection ",
                    titre_supp: "",
                    module: "",
                    contenuHTML: "",
                    template: "",
                    template_view: "/gestion-roles/evenement-date-inspection/",
                    template_depart: "",
                    template_depart_view: "",
                    url: "",
                    taille: "normale",
                    resultat: "",
                    resultat_depart: "",
                    wizard: false,
                    sans_x: true,
                    callback: tenueAJourModal.modalDateInspectionLoaded,
                    boutons: [
                        {
                            type: "cancel",
                            label: "Annuler",
                            title: "",
                            classSupp: "",
                            afficher: true
                        },
                        {
                            type: "save",
                            label: "Sauvegarder",
                            title: "",
                            classSupp: "btn-primary",
                            afficher: true,
                            id: "btn-save-modal-date-inspection",
                            disabled: true
                        }
                    ]
                };

                setTimeout(function () {
                    fenetreModal.creerModal(variableDateInspection, {});
                }, 0);


            } else {
                $('#tenue-a-jour-modal-date-inspection').modal('show');
            }
        }

        if (element === 'btn-tj-supprimer') {

            if (!$('#tenue-a-jour-modal-supprimer-evenement').length) { // si la modal n'a pas déjà été chargé
                var nb_selected = $('#table-evenements,.table-evenements').find('tr:not(.entete-table-liee)').find('input[type="checkbox"]:checked').length;
                var donnees = (nb_selected > 1 ? ' ces ' + nb_selected + ' évènements ' : ' cet évènement ');

                var listeTypeEvenement = [];
                var listeFormulaires = $('#table-evenements,.table-evenements').find('tr:not(.entete-table-liee)').find('input[type="checkbox"]:checked');
                listeFormulaires.each(function () {
                    var row = $(this).closest('tr');
                    var typeEvenement = row.attr('data-id_type_evenement');
                    listeTypeEvenement.push(typeEvenement);
                });


                // #18489
                var html2 = '';
                // Evénement de type opération cadastrale
                if (jQuery.inArray('5', listeTypeEvenement) > -1){
                    html2 = '<br><div><input type="checkbox" id="recharger_operation_cadastrale" class=form-control" checked><span class="text-red" title=""> Recréer automatiquement le ou les évènements d\'Opérations cadastrales qui seront supprimés</span></div>';
                }

                    // Call valider_suppression to attempt to set contenuHTML
                valider_suppression(function(contenuValidation) {
                    var contenuHTML = contenuValidation + html2;
                    var variableSupprimerEvenement = {
                        id: "tenue-a-jour-modal-supprimer-evenement",
                        view: "/core/modal/",
                        id_processus: "",
                        titre: "Souhaitez-vous vraiment supprimer" + donnees + " ?",
                        titre_supp: "",
                        module: "",
                        contenuHTML: contenuHTML,
                        contenuIcone: 'fa-exclamation-triangle orange vertical-align-middle',
                        template: "",
                        template_view: "",
                        template_depart: "",
                        template_depart_view: "",
                        url: "",
                        taille: "normale",
                        resultat: "",
                        resultat_depart: "",
                        wizard: false,
                        sans_x: true,
                        callback: tenueAJourModal.modalSupprimerEvenementLoaded,
                        boutons: [
                            {
                                type: "delete",
                                label: "Oui",
                                title: "",
                                classSupp: "btn-danger",
                                afficher: true,
                                id: "proceder-supprimer-evenement",
                            },
                            {
                                type: "cancel",
                                label: "Non",
                                title: "",
                                classSupp: "",
                                afficher: true
                            }
                        ]
                    };

                    setTimeout(function () {
                        fenetreModal.creerModal(variableSupprimerEvenement, {});
                    }, 0)});
            } else {
                $('#tenue-a-jour-modal-supprimer-evenement').modal('show');
            }
        }

        if (element === 'btn-tj-imprimer') {
            $('body').css('margin-right', '0px'); //PATCH POUR STOPPER LE MOUVEMENT DE LA PAGE VERS LA DROITE À L'OUVERTURE DU MODAL
            $("#exp-ue-langue").val("1");

            $('#modal-message-background').remove();
            $("#liste_ues").empty();
            $('#modal-impression').modal({
                show: true,
                backdrop: 'static'
            });
            var unitesEvaluation = table.rows('.selected').data('id_ue');
                $.each(unitesEvaluation, function (idx, value) {
                    var idUe = value['id_ue'];
                    if (idUe != '') {
                        $("#liste_ues").append(new Option(idUe, idUe, true, true));
                    }
                });
            var dtpicker_options = {
                minDate: new Date(),
                autoUpdateInput: false,
                parentEl: '.datepicker-container',
                autoApply: true,
            };
            var input_dtp = $('#modal-impression').find('.min-today');
            initDatepickerWithOptions(input_dtp, dtpicker_options);
            $("#exp-date-custom-auto-declaration").val(moment().format('YYYY-MM-DD'));
            // #13368: Affichera le champ de date si une des checkbox auto-déclaration est active
            $("input[name*='auto_declaration'], input[name='selection_enquete_ventes'], input[name='generer_lettre_formulaire'][value='invitation'], input[name='generer_lettre_formulaire'][value='rappel']").on('click', function (e) {
                init_checkboxes_autodeclaration_pour_date_custom();
            });
            function init_checkboxes_autodeclaration_pour_date_custom(){
                if ($("input[name='selection_enquete_ventes']").is(':checked') || $("input[name='generer_lettre_formulaire'][value='invitation']").is(':checked') || $("input[name='generer_lettre_formulaire'][value='rappel']").is(':checked') || !$("input[name='selection_auto_declaration'][value='aucun']").is(':checked') ) {
                    $('#exp-date-custom-auto-declaration-wrapper').show();
                } else {
                    $('#exp-date-custom-auto-declaration-wrapper').hide();
                }
            }
            init_checkboxes_autodeclaration_pour_date_custom();
            $('#exp-pdf-separe').off('click').on('click', function(){
                if($('#exp-pdf-separe').is(':checked')){
                    $('#exp-en-inspection').prop('checked', false);
                }
            });

            $('#exp-en-inspection').off('click').on('click', function(){
                if($('#exp-en-inspection').is(':checked')){
                    $('#exp-pdf-separe').prop('checked', false);
                }
            });

            $('#btn-imprimer-modal').off('click').on('click', function () {
                var tableNom = '#' + TABLE_PARENT;
                var table = $(tableNom+',.table-evenements').DataTable();

                var unitesEvaluation = table.rows('.selected').data('id_ue');
                var listeIdUe = [];
                var uesEvenement = [];
                $.each(unitesEvaluation, function (idx, value) {
                    var idUe = value['id_ue'];
                    if (idUe != '') {
                        listeIdUe.push(idUe);
                        uesEvenement = getUesEvenement(value, uesEvenement);
                    }
                });

                $('#' + TABLE_PARENT).find('table[id^=' + TABLE_ENFANT + ']').each(function () {
                    table = $('#' + $(this).attr('id')).DataTable();
                    unitesEvaluation = table.rows('.selected').data('id_ue');

                    $.each(unitesEvaluation, function (idx, value) {
                        var idUe = value['id_ue'];
                        if (idUe != '') {
                            if ($.inArray(idUe, listeIdUe) == -1) {
                                listeIdUe.push(idUe);
                            }
                            uesEvenement = getUesEvenement(value, uesEvenement);
                        }
                    });
                });
                $('#liste_ues_evenement').val(JSON.stringify(uesEvenement));
                $('#liste_unites_evaluation').val(JSON.stringify(listeIdUe));


                let form = $('#form_impression_ue');

                $.ajax({
                    type: "POST",
                    url: form.attr('action'),
                    data: form.serialize(),
                    success: function (response) {
                        messageToastCompteur = 0;
                        infos.ajouterMessageToast({
                            message: response,
                            icone: 'fa-envelope-o ',
                            iconeCouleur: 'green',
                            messageDuree: 5000
                        });
                        table.ajax.reload(null, false);
                    }
                });
            });

            function getUesEvenement(value, uesEvenement) {
                uesEvenement.push({
                    'id_ue': value['id_ue'],
                    'id_evenement': value['id_evenement'],
                    'id_type_evenement': value['id_type_evenement'],
                    'id_statut_evenement': value['id_statut_evenement'],
                    'date_evenement': value['date_evenement'],
                    'id_processus': value['objet_id']
                });
                return uesEvenement;
            }
        }

        if (element === 'btn-tj-afficher-dans-explorateur') {
            afficherTAJDansExplorateur(true);
        }
        if (element === 'btn-taj-automatiser-transfert') {
            modalAutomatiserTransfertEnqueteRevenu();
        }
    }

    /**
     * Activer ou désactiver les actions sur les évènements choisis dans la grille des évènements.
     *
     * @param {string} $selecteur Sélecteur sur le ID (id_evenement) de la rangée.
     * @param {bool} À cocher ou non (true or false).
     * @param {array} Liste des rangées sélectionnées.
     */
    function activerActionsSurEvenementGrille($selecteur, checked, indexes) {
        var boutonsActionDisabled = true;
        var idRapportGroupe = $('[name=hid-id-rapport-groupe]').val();
        var idRapport;
        if(idRapportGroupe !== undefined ) {
            var arrNom = $('.tabbable').find('li.active > a').attr('id').split('-');
            idRapport = arrNom[2];
        }
        var estquilibration = idRapportGroupe == 10 ? '-'+idRapport+'' : '' ;
        for (var i in indexes) {
            var $checkbox = $($selecteur.find('input')[indexes[i]]).show();
            $checkbox.prop("checked", checked);
            i++;
        }

        var element = '.check-taj';
        var nombreIsChecked = $selecteur.closest('#table-evenements'+estquilibration+',.table-evenements').find(element + ":checked");
        if (nombreIsChecked.length === 0) {
            boutonsActionDisabled = true;
        } else {
            boutonsActionDisabled = false;
        }

        var conteneur = $selecteur.closest('.table-template');
        activerDesactiverBoutonsRuban(conteneur, boutonsActionDisabled);
    }

    function valider_suppression(callback)
    {
        var html = ''
        var listeEvenement = [];
        var listeFormulaires = $('#table-evenements,.table-evenements').find('tr:not(.entete-table-liee)').find('input[type="checkbox"]:checked');
        listeFormulaires.each(function () {
            var row = $(this).closest('tr');
            var idEvenement = row.attr('data-id_evenement');
            listeEvenement.push(idEvenement);
        });
        var params = {
                    liste_evenement: JSON.stringify(listeEvenement)
                };
        var jqxhr = $.ajax({
                    type: "POST",
                    url: "/gestion-roles/evenement-supprimer-avertissement/",
                    data: params,
                    dataType: 'html'
                });

                jqxhr
                    .done(function (response) {
                        var reponse = JSON.parse(response);
                        if (reponse.response == 'ok') {
                            html = '<h5 class="modal-title red vertical-align-middle">' + reponse.message+ '</h5>' ;
                            callback(html);

                        }
                    });
    }


    function activerDesactiverBoutonsRuban(conteneur, boutonsActionDisabled) {
        // Si nous avons un ou plusieurs éléments sélectionnés qui sont objets de restrictions, on ajuste les comportements des boutons en conséquence
        var idRapportGroupe = $('[name=hid-id-rapport-groupe]').val();
        var idRapport;
        if(idRapportGroupe !== undefined ) {
            var arrNom = $('.tabbable').find('li.active > a').attr('id').split('-');
            idRapport = arrNom[2];
        }
	    var estquilibration = idRapportGroupe == 10 ? '-'+idRapport+'' : '' ;
        var element = '.check-taj';
        var restrictions = {'37': {'actions': ['btn-tj-assigner-et-etat']}};
        var BoutonsUtilises = ['btn-tj-assigner-et-etat', 'btn-tj-date-inspection', 'btn-tj-supprimer', 'btn-tj-imprimer',
            'btn-tj-exporter-excel', 'btn-tj-afficher-dans-explorateur','btn-tj-exporter-gpx','btn-tj-exporter-google-map',
            'btn-tj-afficher-dans-explorateur-drop-down', 'button-ddr-delai-supplementaire', 'btn-inspection-ouvrir-fiche',
            'btn-taj-generation-rdv', 'btn-tj-change-priorite', 'btn-tj-change-regime-fiscal', "btn-mode-deconnecte",];
        var $selecteur = $(conteneur.context).closest('#table-evenements'+estquilibration+',.table-evenements');
        var elementCoche = $(conteneur.context).closest('tr').attr('data-id_type_evenement');
        if (typeof (elementCoche) === 'undefined') {
            $selecteur = $('#table-evenements'+estquilibration+',.table-evenements');
            elementCoche = $selecteur.closest('tr').attr('data-id_type_evenement');
        }
        $selecteur.find(element + ":checked:not(#" + $(conteneur.context).attr('id') + ")");
        var ElementsCoches = $selecteur.find(element + ":checked:not(#" + $(conteneur.context).attr('id') + ")");

        if (elementCoche in restrictions) {
            if (typeof (elementCoche) === 'undefined') {
                $('#table-evenements'+estquilibration+',.table-evenements').find('tr[data-id_type_evenement=' + elementCoche + ']').find(element + ":checked:not(#" + $(conteneur.context).attr('id') + ")");
            } else {
                $selecteur.find('tr[data-id_type_evenement=' + elementCoche + ']').find(element + ":checked:not(#" + $(conteneur.context).attr('id') + ")");
            }
        }

        var elementRestreintPlusFaible = '';
        var restrictionsAutresListe = $(restrictions).map(function (idx, obj) {
            var elementRestreintPlusFaibleVar = obj[Object.keys(obj)[idx]].actions.length;
            if (elementRestreintPlusFaibleVar < elementRestreintPlusFaible || elementRestreintPlusFaible == '') {
                elementRestreintPlusFaible = {
                    'nom': Object.keys(obj)[idx],
                    'longueur': elementRestreintPlusFaibleVar
                };
            }
            if (Object.keys(obj) !== elementCoche) {
                return Object.keys(obj);
            }
        }).get();
        var restrictionsAutresListeSelecteur = $(restrictionsAutresListe).map(function (idx, value) {
            return 'tr[data-id_type_evenement=' + value + ']';
        }).get(); // Uniquement utilisé pour la sélections de tous les checked qui sont cochés et restreints dans l'utilisation des boutons d'actions sur la table.
        var elementsCochesRestreintsAutres = $selecteur.find(restrictionsAutresListeSelecteur.toString()).find(element + ":checked");

        $.each(BoutonsUtilises, function (idx, obj) {
            var action = boutonsActionDisabled;
            if (elementCoche in restrictions) {
                if (restrictions[elementCoche].actions.indexOf(BoutonsUtilises[idx]) > -1) {
                    action = boutonsActionDisabled;
                } else {
                    action = true;
                }
            }

            // On valide que si tous les boutons avec des restrictions sont décochés, qu'on laisse les autres dans le bon état suivant toujours le principe du moindre privilège.
            if (ElementsCoches.length > 0) {
                if (elementsCochesRestreintsAutres.length > 0) {
                    //    On doit toujours utiliser le principe du moindre privilège sur des actions multiples. Faudait différencier les boutons désactivés pour ce principe pour que les utilisateurs s'en rendent compte.
                    if (restrictions[elementRestreintPlusFaible.nom].actions.indexOf(BoutonsUtilises[idx]) > -1) {
                        action = boutonsActionDisabled;
                    } else {
                        action = true;
                    }
                } else {
                    action = boutonsActionDisabled;
                }
            }
            conteneur.find('[name=' + BoutonsUtilises[idx] + ']').prop("disabled", action);
        });
        var idErevenuExiste = $selecteur.find('.selected').toArray().some(function (element) {
            var estTransferable = $(element).closest('tr').attr('data-est_transferable_vers_fiche');
            return estTransferable === "true" || estTransferable === true;
        });

        var boutonAutomatiserTransfert = conteneur.find('[name="btn-taj-automatiser-transfert"]');
        boutonAutomatiserTransfert.prop("disabled", !idErevenuExiste);

    }

// public API
    return {
        cliquerCaseCocherLigneEvenement: cliquerCaseCocherLigneEvenement,
        actionsBoutonsRuban: actionsBoutonsRuban,
        activerActionsSurEvenementGrille: activerActionsSurEvenementGrille,
        activerDesactiverBoutonsRuban: activerDesactiverBoutonsRuban
    };

})
(); // namespace tenueAJour


function export_xls_taj(my_url) {
    var tableNom = '#' + TABLE_PARENT;
    var table = $(tableNom+',.table-evenements').DataTable();

    var unitesEvaluation = table.rows('.selected').data('id_ue');
    var listeIdUe = [];
    $.each(unitesEvaluation, function (idx, value) {
        var idUe = value['id_ue'];
        if (idUe != '') listeIdUe.push(idUe);
    });

    var idRapport = $('[name=hid-id-rapport]').val();

    // DM: je tente d'alléger cette variable au lieu de la passer au complet dans le POST, sinon on a des problèmes quand on passe par le VPN
    var listeFiltresDef = filtresEvenements.reqListeFiltres();
    var listeFiltres = epurerListeFiltresPost(listeFiltresDef);

    var params = {
        order: table.order(),
        whereSQL: filtresEvenements.faitAppliquerFiltreRecherche(),
        columns: filtresEvenements.reqListeChampsFiltres(),
        listeIdUe: listeIdUe,
        listeFiltres: JSON.stringify(listeFiltres),
        id_rapport: idRapport,
        colonnesDef: JSON.stringify(filtresEvenements.reqColonnesDef())
    };

    wait.start();

    $.ajax({
        type: "POST",
        url: my_url,
        contentType: "application/json",
        data: JSON.stringify(params),
        dataType: 'text',
        success: function (response) {
            infos.ajouterMessageToast({
                message: response,
                messageDuree: 5000
            });
            wait.stop();
        } //end success
    }); //end ajax

}

async function getAllRowsFromAllPages(table) {
    var currentState = table.state.save();
    var initialPage = table.page(); // Store the initial page
    var originalPageLength = table.page.len();// Store the current state
    // Vérifier d'abord le nombre total de lignes
    var totalRows = table.page.info().recordsDisplay;
    if (!verifierNombreElements(totalRows)) {
        // Restaurer l'état initial
        table.state(currentState);
        table.page.len(originalPageLength).draw(false);
        table.page(initialPage).draw(false);
        // Retourner null ou lancer une erreur pour indiquer le dépassement
        return null;
    }

  table.page.len(-1).draw(false); // Show all rows on all pages
  await new Promise((resolve) => table.one('draw', resolve)); // Wait for the table to be fully drawn
  var allRows = table.rows();
  table.state(currentState); // Restore the state
  table.page.len(originalPageLength).draw(false);
  table.page(initialPage).draw(false);
  return allRows;
}

function collectRowsData(rows) {
    if (!rows) return null; // Si rows est null, retourner null
    var listeUe = [];
    var ueDict = {};
    rows.every(function () {
        var row = this.data();
        var idUe = row.id_ue;
        if (!ueDict[idUe]) {
            ueDict[idUe] = true; // Marquer l'ID d'unité d'évaluation comme vu dans le dictionnaire
            listeUe.push(idUe);
        }
    });

    return listeUe;
}

function verifierNombreElements(elements_len) {
    if (!elements_len || elements_len > 2000) {
        infos.ajouterMessageToast({
            message: "Le nombre maximal d'éléments à explorer ne peut pas dépasser 2000.",
            messageCouleur: "red",
            messageDuree: 5000,
            type: 'error'
        });
        return false;
    }
    return true;
}

async function afficherTAJDansExplorateur(decoche_ue=false) {

    var tableNom = `#${TABLE_PARENT}`;
    var table = $(`${tableNom},.table-evenements`).DataTable();

    var allRows;

    var boolSelectAllRows = $(tableNom +',.table-evenements').closest('.table-template').find('.datatables-menu-actions [name=check-tj-select-all]').is(':checked');

    if (boolSelectAllRows) {
        var tableContainer = $('.datatables-menu-actions [name=check-tj-select-all]:checked').closest('.table-template');
        table = tableContainer.find(tableNom+',.table-evenements').DataTable();
        // au cas ou c'est long plusieurs lignes plusieurs pages
        allRows = await getAllRowsFromAllPages(table);
    } else {
        // Otherwise, only select the checked rows on the first page
        allRows = table.rows('.selected');
    }

    var listeUe = collectRowsData(allRows);
    if (!verifierNombreElements(listeUe.length)) return;
    /* les ID UE négatifs ne sont pas retenus, donc si aucun ID UE cela veut dire qu'ils étaient tous négatifs ... */
    if(!listeUe.length) {
        infos.ajouterMessageToast({
            message: "Les ID UE négatifs ne peuvent êtres ajoutés à l'historique ou à la thématique",
            messageCouleur: "red",
            messageDuree: 5000,
            type: 'error'
        });
        return;
    }

    // 19365
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'listeUe';
    input.value = JSON.stringify(listeUe);

    var form = $('#btn_explorer_form');
    form.find('.fields').append(input);
    form.attr('action', `/?idModule=31&decoche_ue=${decoche_ue}`);
    form.submit();
    form.attr('action', '');
    form.find('.fields').html('');
}

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}
const csrftoken = getCookie($('#csrf_cookie_name').val());

function OpenWindowWithPost(url, params, blank=true) {
    var form = document.createElement("form");
    form.setAttribute("method", "get");
    form.setAttribute("action", url)
    if(blank){
        form.setAttribute("target", "_blank");
    }

    for (var i in params) {
        if (params.hasOwnProperty(i)) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = i;
            input.value = params[i];
            form.appendChild(input);
        }
    }

    document.body.appendChild(form);
    //note I am using a post.htm page since I did not want to make double request to the page
    //it might have some Page_Load call which might screw things up.
    form.submit();
    document.body.removeChild(form);
}


function evenement_ouvert_clicked(objet) {
    var row = $(objet).closest('tr');

    var tableElem = row.closest('table');

    var idUe = row.attr('data-id_ue');
    var filtresUe = [{id: idUe}];

    var filtresStatut = [{id: 99}];

    setFiltreValeurs(tableElem, 'id_ue', filtresUe);
    setFiltreValeurs(tableElem, 'id_statut_evenement', filtresStatut);

    var boutonAppliquerFiltre = $('#appliquer-filtre');
    boutonAppliquerFiltre.click();

    return false;
}

// devrait disparaître au profit de celui de gestion-rapport-filtre.js
function setFiltreValeurs(tableElem, nomFiltre, filtres) {
    var tableFiltres = tableElem.data('table-filtres');
    var divFiltre = tableFiltres.find('[id=' + nomFiltre + ']');
    var tdFiltre = divFiltre.closest('td.filtres');
    var delBoutons = tdFiltre.find('button.filtre-close');
    delBoutons.click();

    for (var idx in filtres) {
        var filtre = filtres[idx];
        var id = filtre.id;

        var selectElem = tableFiltres.find('[id=' + nomFiltre + '] select.filtre-select');
        if (selectElem.length) {
            var longId = 'statut-id_statut_evenement-'+id;
            selectElem.val(longId).trigger('change');
        }
        else {
            var textElem = tableFiltres.find('[id=' + nomFiltre + ']');
            textElem.val(id).trigger('change');

            var e = jQuery.Event("keypress");
            e.which = 13; //choose the one you want
            e.keyCode = 13;
            textElem.trigger(e);
        }
    }

    if (nomFiltre == 'id_statut_evenement') {
        var boutons = tdFiltre.find('button.filtre').not('.filtre-close');
        boutons.click();
    }

}

function renderTAJ2note_de_transmission(data, type, row) {
    return data;
}

function renderTAJ2evrdv(data, type, row) {
    // formate le champ pour Demande de Rdv
    var html = '';
    if(row.evrdv_public_id){
        html = '<div><a href="'+row.evrdv_lien+'" target="_blank">'+row.evrdv_public_id+'</a> ['+row.evrdv_status+'] </div>';
    }
    return html;
}



async function modalAutomatiserTransfertEnqueteRevenu() {
    var tableNom = '#' + TABLE_PARENT;
    var table = $(tableNom+',.table-evenements').DataTable();

    var allRows;
    var boolSelectAllRows = $(tableNom +',.table-evenements').closest('.table-template').find('.datatables-menu-actions [name=check-tj-select-all]').is(':checked');

    if (boolSelectAllRows) {
        // au cas ou c'est long plusieurs lignes plusieurs pages
        allRows = await getAllRowsFromAllPages(table);
    } else {
        // Otherwise, only select the checked rows on the first page
        allRows = table.rows('.selected');
    }
    var evenementsAvecType69 = [];
    allRows.every(function () {
    var row = this.data();
    var data_id_evenement = row.id_evenement;

    if (row.est_transferable_vers_fiche) {
        evenementsAvecType69.push(data_id_evenement);
    }
    });

    var data_get = {'liste_even': JSON.stringify(evenementsAvecType69)};
    // 19365
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'listeUe';
    input.value = JSON.stringify(listeUe);

    var form = $('#form_automatiser-transfert');
    form.find('.fields').append(input);

    $('.automatiser-transfert-form-container').empty();

    $.ajax({
        type: "GET",
        url: "gestion-roles/tenue-a-jour/automatiser-transfert-enquete-revenu/",
        data: data_get,
        success: function (response) {
            $('.automatiser-transfert-form-container').html(response);
            var listeIDevenement;
            if ($('#listeIDevenement').val()) {
                listeIDevenement = JSON.parse($('#listeIDevenement').val());
            }
            if (listeIDevenement){
              $('#btn-save-automatiser-transfert').removeAttr('disabled');
            } else {
               $('#btn-save-automatiser-transfert').attr('disabled', 'disabled');
            }

            var data_post = {'liste_even': JSON.stringify(listeIDevenement)};
            $('#form_automatiser-transfert').serializeArray().map(function(obj){
                data_post[obj.name] = obj.value;
            });

            $('#btn-save-automatiser-transfert').off('click').on('click', function (e) {
                e.preventDefault();
                // Récupérez l'URL de l'attribut "action" du formulaire
                var actionUrl = $('#form_automatiser-transfert').attr('action');
                var selectedValue = $('input[name="blocs_transfert"]:checked').val();
                var data_post = {
                    'liste_even': JSON.stringify(listeIDevenement),
                    'blocs_transfert': selectedValue
                };
                // Récupérez les données du formulaire
                wait.start();
                // Effectuez la requête AJAX en utilisant l'URL récupérée
                $.ajax({
                    type: 'POST',
                    url: actionUrl, // Utilisez l'URL récupérée
                    data: data_post,
                    success: function (response) {
                        if (response.msg !== undefined) {
                            $('#modal_automatiser_transfert').modal('hide');
                            // Affichez un message de succès
                            infos.ajouterMessageToast({
                                message: response.msg,
                                messageDuree: 5000,
                                icone: 'fa-check-circle-o',
                                iconeCouleur: 'green'
                            });
                        } else {
                            if (response.errors) {
                                // Effacez d'abord les messages d'erreur précédents
                                infos.ajouterMessageToast({
                                message: response.errors,
                                icone: 'fa-envelope-o ',
                                iconeCouleur: 'red',
                                messageDuree: 5000
                            });
                            }
                        }
                        refreshDatatables();
                        wait.stop();
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        $('.automatiser-transfert-form-container').html(jqXHR.responseText);
                    }
                });
            });

            $('#modal_automatiser_transfert').modal({
                show: true,
                backdrop: 'static'
            });
        }
    });
}

$(document).ready(function() {
    $('[data-toggle="tooltip"]').tooltip();
});
